import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { VclAutocompleteModule, VclModalModule } from '@voxel/community';
import {
  VoxelCheckboxModule,
  VoxelFormFieldModule,
  VoxelInputModule,
  VoxelLinkModule,
  VoxelModalModule,
} from '@voxel/mobile';
import { LottieAnimationViewModule } from 'ng-lottie';

import { SharedModule } from '../../shared/shared.module';
import { AccountInfoCreationComponent } from './account-info-creation/account-info-creation.component';
import { DetailAccountCreationComponent } from './detail-account-creation/detail-account-creation.component';
import { InvitationRegisterComponent } from './invitation-register/invitation-register.component';
import { SignOnRoutes } from './sign-on.routes';
import { SuccessfulAccountCreationComponent } from './successful-account-creation/successful-account-creation.component';
import {
  SuccessfulCreditCardCreationComponent,
} from './successful-credit-card-creation/successful-credit-card-creation.component';
import { BondingComponent } from './bonding/bonding/bonding.component';
import { BondingSuccessfullyCreatedComponent } from './bonding/bonding-successfully-created/bonding-successfully-created.component';
import { EndingBondingComponent } from './bonding/ending-bonding/ending-bonding.component';
import { PrincipalityCreditCardComponent } from './principality-credit-card/principality-credit-card.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    SignOnRoutes,
    VclModalModule,
    VoxelLinkModule,
    VoxelInputModule,
    VoxelModalModule,
    ReactiveFormsModule,
    VoxelCheckboxModule,
    VoxelFormFieldModule,
    VclAutocompleteModule,
    LottieAnimationViewModule.forRoot(),
  ],
  providers: [],
  declarations: [
    DetailAccountCreationComponent,
    SuccessfulAccountCreationComponent,
    AccountInfoCreationComponent,
    SuccessfulCreditCardCreationComponent,
    InvitationRegisterComponent,
    BondingComponent,
    BondingSuccessfullyCreatedComponent,
    EndingBondingComponent,
    PrincipalityCreditCardComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})

export class SignOnModule { }
